<div class="box box-white has-shadow" *ngIf="hasFinishedConfiguration">
    <div class="box-header box-body">

        <div class="box-header-icon">
            <i class="icon-home"></i>
        </div>

        <div class="box-header-title" *ngIf="policyNumber === null">
            {{ 'OFFER_CONFIG.WELTH' | translate }}
        </div>

        <div class="box-header-title" *ngIf="policyNumber !== null">
            {{ 'OFFER_CONFIG.WELTH_POLICY' | translate : {number: policyNumber} }}
        </div>

        <div *ngIf="readonly && previewEnabled" class="box-action text-accent">
            <button class="btn btn-link btn-slim btn-no-padding"
                    (click)="preview()">
                <i class="icon-preview mr-2"></i>
                <span>{{'PREVIEW' | translate }}</span>
            </button>
        </div>
    </div>

    <div class="box-content">
        <div class="box-body">
            <div class="box-row has-padding">
                <div class="box-item">
                    <div class="row">
                        <div class="mobile col-3" *ngIf="!fullInsuranceDate">
                            <app-output [label]="'OFFER_CONFIG.PROTECTION_PERIOD' | translate">
                                {{ configuration.insuranceStartDate | lsnDate }}
                                - {{ configuration.insuranceEndDate | lsnDate }}
                            </app-output>
                        </div>
                        <div class="mobile col-3" *ngIf="fullInsuranceDate">
                            <app-output [label]="'OFFER_CONFIG.PROTECTION_PERIOD' | translate">
                                {{ product.insuranceStart | lsnDate : 'yyyy-MM-dd HH:mm'}}
                                - {{ product.insuranceEnd | lsnDate : 'yyyy-MM-dd HH:mm'}}
                            </app-output>
                        </div>
                        <div class="mobile col-2">
                            <app-output [label]="'OFFER_CONFIG.ESTATE_TYPE' | translate">
                                {{ configuration.propertyType.description }}
                            </app-output>
                        </div>
                        <div class="mobile col">
                            <app-output [label]="'INSURED_OBJECT' | translate">
                                {{ configuration.address.fullAddress }}
                            </app-output>
                        </div>

                        <div class="col-12">
                            <app-output [label]="'OFFER_CONFIG.INSURANCE_COVERAGE' | translate">
                                {{ insuranceScope }}
                            </app-output>
                        </div>
                    </div>
                </div>
            </div>

            <div class="box-row" *ngIf="!readonly && !configuration.cession">
                <div class="box-item text-accent">
                    <button class="btn btn-link btn-slim" type="button" (click)="editCession()">
                        <i class="icon-add mr-2"></i>
                        <span>{{ 'BUTTON.ADD_CESSION' | translate }}</span>
                    </button>
                </div>
            </div>

            <div class="box-row has-padding" *ngIf="configuration.cession">
                <div class="box-item">
                    <div class="w-100">
                        <div class="row">
                            <div class="col">
                                <app-output [label]="'CESSIONARY_DATA' | translate">
                                    <div>{{ configuration.cession.name }}</div>
                                    <ng-container
                                            *ngIf="configuration.cession.type.code === cessionPartyType.LEGAL_ENTITY">
                                        <div>
                                            {{ 'LABEL.NIP' | translate }}: {{ configuration.cession.nip }}
                                        </div>
                                        <div>
                                            {{ 'LABEL.REGON' | translate }}: {{ configuration.cession.regon }}
                                        </div>
                                        <div>
                                            {{ configuration.cession.address.fullAddress }}
                                        </div>
                                    </ng-container>
                                </app-output>
                            </div>

                            <div class="col-auto align-self-center justify-content-end"
                                 *ngIf="!readonly">
                                <button class="btn btn-link btn-slim"
                                        (click)="deleteCession()"
                                        [matTooltip]="'BUTTON.DELETE_CESSION' | translate">
                                    <i class="icon-delete mr-1"></i>
                                </button>

                                <button class="btn btn-link btn-slim"
                                        [matTooltip]="'BUTTON.EDIT_CESSION' | translate"
                                        (click)="editCession()">
                                    <i class="icon-edit"></i>
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>

    <div class="box-footer" *ngIf="hasFinishedConfiguration">
        <div class="box-body">
            <div class="row no-gutters">

                <div class="installment has-payment" *ngIf="configuration?.paymentDefinition.installmentList">
                    <div class="installment-title">
                        {{ 'OFFER_CONFIG.PAYMENTS' | translate }}
                    </div>

                    <div class="installment-body">
                        <div class="installment-item"
                             *ngFor="let element of configuration?.paymentDefinition.installmentList; let index = index">
                            <!-- if regular installment-->
                            <ng-container *ngIf="!hasPayment || index > 0">
                                <div class="payment-values">
                                    <div class="item-price">{{ element.amount | premium}}</div>
                                    <div class="item-date">{{ element.date | lsnDate}}</div>
                                </div>
                            </ng-container>

                            <!-- if payment installment-->
                            <button *ngIf="hasPayment && index === 0 && toPay(policy.orderId)"
                                    (click)="pay(policy)"
                                    class="btn btn-primary btn-no-width btn-same-padding payment-button">
                                <span class="row no-gutters">
                                    <div class="col price text-price column price-left-fix">
                                        <div class="item-price">{{ element.amount | premium}}</div>
                                        <div class="item-date mt-4 no-brake">{{ element.date | lsnDate}}</div>
                                    </div>
                                    <div class="col-auto pay">
                                        {{'BUTTON.PAY' | translate}}
                                    </div>
                                </span>
                            </button>

                            <!-- if payment pending-->
                            <ng-container
                                    *ngIf="hasPayment && index === 0 && isPending(policy.orderId)">
                                <div class="payment-button has-pending">
                                <span class="row no-gutters">
                                    <div class="col price text-price column price-left-fix">
                                        <div class="item-price">{{ element.amount | premium}}</div>
                                        <div class="item-date mt-4 no-brake">{{ element.date | lsnDate}}</div>
                                    </div>
                                    <div class="col-auto pay">
                                        {{'BUTTON.PAYMENT_PENDING' | translate}}
                                    </div>
                                </span>
                                </div>
                            </ng-container>

                            <!-- if payment success-->
                            <ng-container *ngIf="hasPayment && index === 0 && isPaid(policy.orderId)">
                                <div class="payment-button has-success">
                                    <span class="row no-gutters">
                                        <div class="col price text-price column price-left-fix">
                                            <div class="item-price">{{ element.amount | premium}}</div>
                                            <div class="item-date mt-4 no-brake">{{ element.date | lsnDate}}</div>
                                        </div>
                                        <div class="col-auto pay">
                                            {{'BUTTON.PAYMENT_SUCCESS' | translate}}
                                        </div>
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="col"></div>

                <div class="text-price column">
                    <div class="item-text">{{ 'LABEL.PREMIUM' | translate }}</div>
                    <div class="item-price">{{ configuration.premium | premium }}</div>
                </div>
            </div>

            <div class="mt-5">
                <table class="table table-simple">
                    <thead>
                    <tr>
                        <td>{{ 'LABEL.FILE_NAME' | translate }}</td>
                        <td class="text-accent text-right">
                            <a (click)="download(true)" class="btn btn-link btn-no-padding">
                                {{'BUTTON.DOWNLOAD_ALL' | translate}} <i class="icon-download-2 ml-2"></i>
                            </a>
                        </td>
                    </tr>
                    </thead>

                    <tbody>
                    <tr>
                        <td>{{ printoutLabel | translate }}</td>
                        <td class="text-accent text-right">
                            <a (click)="download(false)" target="_blank" class="btn btn-link btn-no-padding">
                                <i class="icon-download-2"></i>
                            </a>
                        </td>
                    </tr>
                    <tr *ngIf="type === summaryType.POLICY">
                        <td>{{ 'LABEL.SUMMARY_PRINTOUT' | translate }}</td>
                        <td class="text-accent text-right">
                            <a (click)="downloadSummary()"
                               target="_blank"
                               class="btn btn-link btn-no-padding">
                                <i class="icon-download-2"></i>
                            </a>
                        </td>
                    </tr>

                    <tr *ngFor="let file of configuration.documentList">
                        <td>{{ file.label?.description }}</td>
                        <td class="text-right" [class.text-accent]="file.href">
                            <a *ngIf="file.href"
                               [href]="file.href"
                               target="_blank"
                               class="btn btn-link btn-no-padding">
                                <i class="icon-download-2"></i>
                            </a>
                            <ng-container *ngIf="file.info">{{ file.info | translate }}</ng-container>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
